import { get } from 'utils/helpers/lodash';

export type SortOrder = 'ASC' | 'DESC';

const compareFn = (
  a: number | string,
  b: number | string,
  order: SortOrder,
) => {
  let compareA = a;
  let compareB = b;

  if (typeof a === 'string') {
    compareA = a.toLowerCase();
  }

  if (typeof b === 'string') {
    compareB = b.toLowerCase();
  }

  if (compareA < compareB) {
    return order === 'ASC' ? -1 : 1;
  }
  if (compareA > compareB) {
    return order === 'ASC' ? 1 : -1;
  }
  return 0;
};

const sortFn = (arr: (string | number)[], order: SortOrder) => {
  return arr.sort((a, b) => compareFn(a, b, order));
};

const objectSortFn = <T>(
  arr: T[],
  value: string,
  order: SortOrder,
  compareType?: 'date',
): T[] => {
  let invalidCompareProperties = false;

  const sortedArray = arr.sort((a: T, b: T) => {
    let valueA = get(a, value) || '';
    let valueB = get(b, value) || '';

    if (compareType === 'date') {
      valueA = new Date(valueA).getTime();
      valueB = new Date(valueB).getTime();

      if (valueA < 1 || valueB < 1) {
        invalidCompareProperties = true;
        // eslint-disable-next-line no-console
        console.warn(
          'Compare parameters are not valid dates. Original array returned',
        );
      }
    }

    const valueAIsNumberOrString =
      typeof valueA === 'number' || typeof valueA === 'string';

    const valueBIsNumberOrString =
      typeof valueB === 'number' || typeof valueB === 'string';

    if (!valueAIsNumberOrString || !valueBIsNumberOrString) {
      invalidCompareProperties = true;
      // eslint-disable-next-line no-console
      console.warn(
        `Compare parameters must be a number or a string.${valueA} is of type ${typeof valueA} and ${valueB} is of type ${typeof valueB}. Original array returned`,
      );
    }

    return compareFn(valueA, valueB, order);
  });

  if (invalidCompareProperties) {
    return arr;
  }
  return sortedArray;
};

export { sortFn, objectSortFn };
